<template>
  <div class="ContactEdit" v-if="contact && contact.uuid">
    <h2>
      Éditer un contact ({{ contact.first_name }} {{ contact.last_name }})
    </h2>
    <hr />
    <help-message>
      <h3>Éditer un contact</h3>
      <p>
        La seule subtilité lors de l'édition de contact consiste dans le fait
        qu'<strong>un contact est lié à une entreprise.</strong><br />C'est à
        dire que si un contact change d'entreprise, et intervient sur plusieurs
        projets, parfois pour une entreprise, puis pour l'autre, il faudra
        <strong>garder deux fiches distinctes pour ce contact.</strong
        ><br />Cela évite d'avoir à maintenir un historique de statut salarial
        de chaque contact, avec des variances de numéro de téléphone, métier
        exercé, e-mail, [...].<br />Pour simplifier cela, vous pouvez utiliser
        la case à cocher "y travaille toujours".<br />Cela permettra de chercher
        dans les fiches contact actuelles uniquement, lorsque le carnet de
        contacts sera activé.
      </p>
    </help-message>
    <div class="columns is-multiline">
      <div class="column is-half">
        <horiz-field>
          <label class="label" slot="label">Prénom</label>
          <input type="text" class="input" v-model="contact.first_name" />
        </horiz-field>
        <horiz-field>
          <label class="label" slot="label">Mail</label>
          <input type="text" class="input" v-model="contact.email" />
        </horiz-field>
        <horiz-field>
          <label slot="label" class="label">Entreprise</label>
          <partner-suggestor
            :item="contact.partner_id"
            @update="contact.partner_id = $event"
          ></partner-suggestor>
        </horiz-field>
        <horiz-field>
          <label for="" class="label" slot="label"
            >Y travaille toujours ?</label
          >
          <input
            type="checkbox"
            class="checkbox"
            @change="contact.still_working = $event.target.checked"
            :checked="contact.still_working"
          />
        </horiz-field>
      </div>
      <div class="column is-half">
        <horiz-field>
          <label class="label" slot="label">Nom</label>
          <input type="text" class="input" v-model="contact.last_name" />
        </horiz-field>
        <horiz-field>
          <label class="label" slot="label">Tél.</label>
          <input type="text" class="input" v-model="contact.telephone" />
        </horiz-field>
        <horiz-field>
          <label class="label" slot="label">Métier</label>
          <div>
            <kv-suggestor
              :type="'fonctions'"
              @update="contact.fonction_id = $event"
              :item="contact.fonction_id"
            ></kv-suggestor>
          </div>
        </horiz-field>
        <horiz-field>
          <label class="label" slot="label">Diplôme</label>
          <kv-suggestor
            :type="'diplomas'"
            @update="contact.diploma_id = $event"
            :item="contact.diploma_id"
          >
          </kv-suggestor>
        </horiz-field>
      </div>
    </div>
    <div class="buttons">
      <button
        class="button is-primary"
        :class="loading ? 'is-loading' : ''"
        @click="save"
      >
        Enregistrer
      </button>
    </div>
  </div>
</template>

<script>
import { types as t } from "../../store/actions/contacts";
import HorizField from "../../components/Form/HorizField";
import KvSuggestor from "../../components/Form/KvSuggestor";
import PartnerSuggestor from "../../components/Form/PartnerSuggestor";
import { setSaveState } from "../../util/func";
import HelpMessage from "../../components/Form/HelpMessage";

export default {
  name: "ContactEdit",
  components: { HelpMessage, PartnerSuggestor, KvSuggestor, HorizField },
  props: {
    uuid: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      contact: {},
      loading: false
    };
  },
  methods: {
    async save() {
      this.loading = true;
      setTimeout(async () => {
        await this.$store.dispatch(t.UPDATE_CONTACT, this.contact);
        setSaveState(this.$router);
        this.loading = false;
      }, 500);
    }
  },
  async mounted() {
    this.contact = await this.$store.dispatch(t.GET_CONTACT_BY_UUID, this.uuid);
  }
};
</script>

<style lang="scss">
.ContactEdit {
}
</style>
